import { render, staticRenderFns } from "./closer.vue?vue&type=template&id=40274d61&"
import script from "./closer.vue?vue&type=script&lang=js&"
export * from "./closer.vue?vue&type=script&lang=js&"
import style0 from "./closer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40274d61')) {
      api.createRecord('40274d61', component.options)
    } else {
      api.reload('40274d61', component.options)
    }
    module.hot.accept("./closer.vue?vue&type=template&id=40274d61&", function () {
      api.rerender('40274d61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/closer/closer.vue"
export default component.exports